import React from 'react';
import { Card, CardContent } from '../ui/card';
import { TrendingUp, TrendingDown, Activity, Wallet, Target, Sparkles } from 'lucide-react';

export function DCAStats() {
  // Mock data - will be replaced with real data from backend/contracts
  const stats = {
    totalStrategies: 3,
    activeStrategies: 2,
    totalInvested: '2,500.00',
    totalValue: '2,847.32',
    overallPnL: '+347.32',
    overallPnLPercentage: 13.89,
    totalExecutions: 47,
    averageSavings: '3.2%',
  };

  const isProfit = stats.overallPnLPercentage >= 0;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-600 dark:text-slate-400">Estrategias Activas</p>
              <p className="text-2xl font-bold text-slate-900 dark:text-slate-100">
                {stats.activeStrategies}/{stats.totalStrategies}
              </p>
            </div>
            <div className="p-2 bg-violet-500/20 rounded-lg">
              <Activity className="h-5 w-5 text-violet-500" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-600 dark:text-slate-400">Total Invertido</p>
              <p className="text-2xl font-bold text-slate-900 dark:text-slate-100">
                ${stats.totalInvested}
              </p>
            </div>
            <div className="p-2 bg-blue-500/20 rounded-lg">
              <Wallet className="h-5 w-5 text-blue-500" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-600 dark:text-slate-400">Valor Actual</p>
              <p className="text-2xl font-bold text-slate-900 dark:text-slate-100">
                ${stats.totalValue}
              </p>
              <p className={`text-sm flex items-center gap-1 ${isProfit ? 'text-green-500' : 'text-red-500'}`}>
                {isProfit ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
                {stats.overallPnL} ({stats.overallPnLPercentage}%)
              </p>
            </div>
            <div className={`p-2 rounded-lg ${isProfit ? 'bg-green-500/20' : 'bg-red-500/20'}`}>
              <Target className={`h-5 w-5 ${isProfit ? 'text-green-500' : 'text-red-500'}`} />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-600 dark:text-slate-400">Ahorro Smart Timing</p>
              <p className="text-2xl font-bold text-green-500">
                {stats.averageSavings}
              </p>
              <p className="text-sm text-slate-600 dark:text-slate-400">
                {stats.totalExecutions} ejecuciones
              </p>
            </div>
            <div className="p-2 bg-amber-500/20 rounded-lg">
              <Sparkles className="h-5 w-5 text-amber-500" />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
